/*
 * The market's own clock. Pinned rather than left to the runtime because the same instant would
 * otherwise format one way on the server and another in the browser, which hydration reports as
 * a mismatch.
 */
const MARKET_TIME_ZONE = 'Europe/Copenhagen';

/** Time of day only, e.g. `20.00` in `da-DK`. */
export const formatTimeOfDay = (date: Date, locale: string = 'da-DK'): string =>
    new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: MARKET_TIME_ZONE,
    }).format(date);

export const getDateByTime = (time: string) => {
    const [hours, minutes] = time.split(':').map((t) => parseInt(t, 10));
    const date = new Date().setHours(hours, minutes ?? 0);

    return date;
};

export const isNowBetweenDates = (start: string | null, end: string | null) => {
    if (!start || !end) return false;

    const startDate = getDateByTime(start);
    const endDate = getDateByTime(end);

    const now = new Date().getTime();

    return startDate <= now && now <= endDate;
};

export const evaluateDate = (dateToEval: unknown) => {
    if (typeof dateToEval === 'string' || typeof dateToEval === 'number') {
        const date = new Date(dateToEval);

        if (!isNaN(date.getTime())) return date;
    }

    if (typeof dateToEval === 'object' && dateToEval instanceof Date) return dateToEval;

    return undefined;
};

export const storeWillOpen = (start: string | null) => {
    if (!start) return false;
    const startDate = getDateByTime(start);
    const now = new Date().getTime();

    return now < startDate;
};
